import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "content" }

import Banner from "./Banner.vue";
import Block from "./BlockArea.vue";
import Tx from "./TxArea.vue";
import HomeMixins from "@/mixins/home";
import { onBeforeUnmount } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const { getLastBlock } = HomeMixins();
getLastBlock();
let Timer: number = window.setInterval(() => getLastBlock(), 10000);

onBeforeUnmount(() => {
  clearInterval(Timer);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Banner),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Block),
      _createVNode(Tx)
    ])
  ]))
}
}

})